import { ErrorResolution } from '../../../../app/common/errorResolution/errorResolution';
import { IRewardsTransactionsHistoryResponse } from '../../rewardsClub.interface';

export enum RewardsTransactionsHistoryActionTypes {
    GET_REWARDS_TRANSACTIONS_HISTORY_REQUEST = 'GET_REWARDS_TRANSACTIONS_HISTORY_REQUEST',
    GET_REWARDS_TRANSACTIONS_HISTORY_SUCCESS = 'GET_REWARDS_TRANSACTIONS_HISTORY_SUCCESS',
    GET_REWARDS_TRANSACTIONS_HISTORY_FAILURE = 'GET_REWARDS_TRANSACTIONS_HISTORY_FAILURE',
}

export type RewardsTransactionsHistoryAction =
    | {
          type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_REQUEST;
      }
    | {
          type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_SUCCESS;
          rewardsTransactionsHistoryResponse: IRewardsTransactionsHistoryResponse;
      }
    | {
          type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_FAILURE;
          error: ErrorResolution;
      };
